import classnames from 'classnames';
import React, { useContext } from 'react';
import { EnergyUsageCostContext } from '@/pages/EnergyUsageCostKanban';
import styles from './index.module.scss';
import NoDataPic from './noDataPic.png';
import { UnitItemCostProps } from '.';
import { formatThousandUnit } from '@/utils/utils';

interface CardItemProps {
  overview: UnitItemCostProps;
  swiperUnitId?: number;
  setSwiperUnitId?: (id: number) => void;
}

const CardItem: React.FC<CardItemProps> = ({ overview, swiperUnitId, setSwiperUnitId }) => {
  const { setUnitId, setShowDetail } = useContext(EnergyUsageCostContext);

  return (
    <div
      className={classnames(styles.cardBox, swiperUnitId === overview.energyUnitId && styles.currentBox)}
      onClick={() => setSwiperUnitId?.(overview.energyUnitId!)}
    >
      <div className={styles.boxHeader}>
        <div className={styles.title}>{overview.energyUnitName}</div>
        <div className={styles.link}>
          {overview.detailList?.length ? (
            <span
              onClick={() => {
                setShowDetail?.(true);
                setUnitId?.(overview.energyUnitId);
              }}
            >
              详情
            </span>
          ) : null}
        </div>
      </div>
      {overview.detailList?.length ? (
        <div className={styles.infoBox}>
          <div key={overview.energyUnitId} className={styles.infoLine}>
            <div className={styles.medium}>总成本</div>
            <div className={styles.val}>{formatThousandUnit(overview.totalCost!)}元</div>
          </div>
          {overview.detailList.map(item => {
            return (
              <div key={item.id} className={styles.infoLine}>
                <div className={styles.medium}>{item.name}</div>
                <div className={styles.val}>{formatThousandUnit(item.value)}元</div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={styles.emptyPic}>
          <img src={NoDataPic} alt="" />
          <div>暂无数据</div>
        </div>
      )}
    </div>
  );
};

export default CardItem;
